var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C8.05869 0 0 8.03863 0 17.9542C0 27.8704 8.05869 35.909 18 35.909C27.9407 35.909 36 27.8704 36 17.9542C36 8.03863 27.9407 0 18 0ZM22.7406 13.9107L22.4831 17.1326H19.0489V28.3266H14.7111V17.1326H12.3959V13.9107H14.7111V11.7453C14.7111 10.7926 14.7362 9.3198 15.4565 8.4078C16.2155 7.44351 17.2579 6.7878 19.049 6.7878C21.9681 6.7878 23.199 7.18731 23.199 7.18731L22.62 10.4873C22.62 10.4873 21.6558 10.2189 20.7554 10.2189C19.855 10.2189 19.049 10.528 19.049 11.3948V13.9107H22.7406Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookB);
export default __webpack_public_path__ + "static/media/facebookB.33dba8c798b13fe7d3fc93e5d80f8345.svg";
export { ForwardRef as ReactComponent };